import {
    FETCH_ERRORS_FILTER,
    CHANGE_ERROR_MASTER_DEGREE,
    DELETE_ERROR,
    NEW_ERROR,
    EDIT_ERROR
} from '../actions/types';

const initialState = {
    items: [],
    item: {}
}

export default function(state=initialState, action) {
    switch(action.type) {
        case FETCH_ERRORS_FILTER:
            return {
                ...state,
                items: action.payload
            }
        case NEW_ERROR:
            return {
                ...state,
                item: action.payload
            }
        case EDIT_ERROR:
            return {
                ...state,
                item: action.payload
            }
        case CHANGE_ERROR_MASTER_DEGREE:
            return {
                ...state,
                item: action.payload
            }
        case DELETE_ERROR:
            return {
                ...state,
                item: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js